import { createSlice } from "@reduxjs/toolkit";
import { get_req } from "../Utilities/apiUtil";
import { bhshops_get_all_cities_url, bhshops_get_all_collection_points_url } from "../Utilities/apiUrl";
import { errorActions } from './errorSlice';

export const fetchAllShopsCities = () => {
    return async (dispatch) => {
        const fetchData = async () => {
            try {
                const data = await get_req(bhshops_get_all_cities_url);
                dispatch(errorActions.setError(!data.isValid));
                return data;
            }
            catch (error) {
                dispatch(errorActions.setError(true));
            }
        }
        try {
            const cities = await fetchData();
            dispatch(errorActions.setError(!cities.isValid));
            dispatch(shopsActions.setCities(cities));
        }
        catch (error) {
            dispatch(errorActions.setError(true));
        }
    }
}

export const fetchAllShopsCollectionPoints = (city) => {
    return async (dispatch) => {
        const fetchData = async () => {
            try {
                const data = await get_req(`${bhshops_get_all_collection_points_url}&city=${city}`);
                dispatch(errorActions.setError(!data.isValid));
                return data;
            }
            catch (error) {
                dispatch(errorActions.setError(true));
            }
        }
        try {
            const collectionPoints = await fetchData();
            dispatch(errorActions.setError(!collectionPoints.isValid));
            dispatch(shopsActions.setCollectionPoints(collectionPoints));
        }
        catch (error) {
            dispatch(errorActions.setError(true));
        }
    }
};

const ShopsSlice = createSlice({
    name: 'shops',
    initialState: {
        cities: [],
        collectionPoints: [],
        city: "",
        site: "",
        siteId: -1,
        isFormSubmited: false,
        isValid: false
    },
    reducers: {
        setCities: (state, action) => {
            state.cities = [...action.payload.payload.slice()];
        },
        setCollectionPoints: (state, action) => {
            state.collectionPoints = [...action.payload.payload.slice()];
        },
        setCity: (state, action) => {
            state.city = action.payload.city;
        },
        setSite: (state, action) => {
            state.site = action.payload.site;
        },
        setSiteId: (state, action) => {
            state.siteId = action.payload.siteId;
        },
        setIsFormSubmited: (state, action) => {
            state.isFormSubmited = action.payload.isFormSubmited
        },
        setIsValid: (state, action) => {
            state.isValid = action.payload.isValid
        }
    }
});
export const shopsActions = ShopsSlice.actions;
export default ShopsSlice;